import { createStore } from 'vuex'

export default createStore({
  state: {
    user: localStorage.getItem('username')
      ? {
        username: localStorage.getItem('username'),
        role: localStorage.getItem('role')
      }
      : null,
    token: localStorage.getItem('token') || null,
  },
  mutations: {
    setUser(state, user) {
      state.user = { ...user };
      localStorage.setItem('username', user.username); // Met à jour l'utilisateur dans localStorage
      localStorage.setItem('role', user.role)
    },
    setToken(state, token) {
      state.token = token;
      localStorage.setItem('token', token);
    },
    clearAuth(state) {
      state.token = null;
      state.user = null;
      localStorage.removeItem('token');
      localStorage.removeItem('username');
      localStorage.removeItem('role');
    }
  },
  actions: {
    login({ commit }, token) {
      try {
        //  Décoder le token et vérifier les erreurs
        const decodedToken = JSON.parse(atob(token.split('.')[1]));

        // Vérification de l'expiration du token
        const isExpired = decodedToken.exp ? Date.now() >= decodedToken.exp * 1000 : true;
        if (isExpired) {
          console.error('Token expiré');
          commit('clearAuth');
          return;
        }

        //  Stocker le token et l'utilisateur
        commit('setToken', token);
        commit('setUser', { username: decodedToken.username, role: decodedToken.role });
      } catch (error) {
        console.error('Erreur lors du décodage du token JWT', error);
        commit('clearAuth');
      }
    },
    logout({ commit }) {
      commit('clearAuth');
    },
    checkAuth({ commit, state }) {
      if (state.token) {
        try {
          const decodedToken = JSON.parse(atob(state.token.split('.')[1]));

          //  Vérification de l'expiration du token
          const isExpired = Date.now() >= decodedToken.exp * 1000;
          if (isExpired) {
            console.error('Token expiré');
            commit('clearAuth');
            return;
          }

          commit('setUser', decodedToken);
        } catch (error) {
          console.error('Erreur lors du décodage du token JWT', error);
          commit('clearAuth');
        }
      }
    }
  },
  getters: {
    user: (state) => state.user,
    role: (state) => state.user?.role || 'Utilisateur',
    token: (state) => state.token,
    isLoggedIn: (state) => !!state.token,
    isAdmin: (state) => state.user?.role === 'admin',
  }
});
